import { Injectable } from '@angular/core';
import { ColorService } from './color.service';
import { Subscription } from 'rxjs';
import { EventService } from './event.service';

@Injectable({
  providedIn: 'root'
})
export class NodeService {


  sourceNodeMiddle: any;
  targetNodeMiddle: any;
  nodeMiddle: any;
  nodeMiddleSubscription: Subscription;
  edgeMiddle: any;

  constructor(private colorService: ColorService,
    private eventService: EventService) {
    colorService = this.colorService;

    this.nodeMiddleSubscription = this.eventService.nodeMiddleSubject.subscribe(obj => {
      this.nodeMiddle = obj['nodeMiddle'];
      this.addEdgeNodeMiddle(obj['that']);
    });

  }



  getNodeById(id, that) {
    return that.cy.nodes('[id="' + id + '"]');
  }

  renameNode(node, that) {
    const currentLabel = node.data('label');
    const newLabel = prompt('Quel nom pour ce noeud ?', currentLabel);
    if (newLabel !== currentLabel) {
      node.data('label', newLabel);
    }
    that.emitChange('update');
  }

  getUniqueNodeId(that) {
    const usedId = that.cy.nodes().map((el) => {
      return el.data('id');
    });

    const id = Math.round(100000 * Math.random()).toString(10);
    const idAlreadyExist = usedId.indexOf(id) !== -1;

    if (idAlreadyExist) {
      return this.getUniqueNodeId(that);
    }

    return id;
  }

  getLastNodeId(that) {
    const nodes = that.cy.nodes();
    // console.log(nodes[nodes.length - 1].data('id'));
  }

  getParentNode(node, that) {
    const nodeId = node.data('id');
    const parentNodeId = node.connectedEdges('[target="' + nodeId + '"]').data('source');
    return that.cy.nodes('[id="' + parentNodeId + '"]');
  }
  getChildrenNode(node, that) {
    const nodeId = node.data('id');
    const listNode: any = [];
    let listEdges = node.connectedEdges('[source="' + nodeId + '"]');
    if (listEdges.length > 0) {
      delete listEdges['_private'];
      delete listEdges['length'];
      listEdges = Object.values(listEdges);
      let e: any;
      for (e in listEdges) {
        e = listEdges[e];
        listNode.push(this.getNodeById(e.data('target'), that));
      }

    }
    return listNode;

  }

  updateInformationNode(node, that) {
    node.data('label', that.formNode.value.name);
    node.data('description', that.formNode.value.description);
    node.style('background-color', that.formNode.value.color);
    node.style('width', that.getWitdth(that.formNode.value.name));
    this.updateColorBranchNode(node, that.formNode.value.color, that);
  }
  saveNameNodeRoot(name, that: any) {
    const node = this.getNodeById('n', that);
    node.data('label', name);
    const selector = 'node[id="n"]';
    that.cy.style().selector(selector).style({
      'width': that.getWitdth(name),
      'background-color': 'white',
      'font-size': 10,
      'border-width': '1',
      'border-color': 'black'
    }).update();
    that.nameNodeRoot = '';
  }

  merge_array(array1, array2) {
    const result_array = [];
    const arr = array1.concat(array2);
    let len = arr.length;
    const assoc = {};

    while (len--) {
      const item = arr[len];

      if (!assoc[item]) {
        result_array.unshift(item);
        assoc[item] = true;
      }
    }

    return result_array;
  }

  getBranchConnected(node, result, used, that) {
    // init variable
    let arrayResult = [];
    let arrayIdTested = [];
    const idNode = node.data('id');

    // on merge avce les paramÃ¨tres

    arrayResult = this.merge_array(arrayResult, result);
    arrayIdTested = this.merge_array(used, arrayIdTested);



    if (idNode !== 'n') {
      arrayIdTested.push(idNode);
      const allNodesConnected = this.getNodeConnected(this.getNodeById(idNode, that));
      arrayResult = this.merge_array(arrayResult, allNodesConnected);
      if (allNodesConnected.length > 0) {
        for (let id in allNodesConnected) {
          id = allNodesConnected[id];
          if (id !== 'n' && !arrayIdTested.includes(id)) {
            arrayResult.push(id);
            arrayIdTested.push(id);
            const test = this.getBranchConnected(this.getNodeById(id, that), arrayResult, arrayIdTested, that);
            arrayResult = this.merge_array(arrayResult, test);
          }

        }
      }
    }
    // retorune un tableau d'id de node
    return arrayResult;
  }


  getNodeConnected(node) {
    const idNode = node.data('id');
    const result = [];
    let objectToArray;
    const allNodesConnected = node.connectedEdges('edge[secondary="' + false + '"]');
    delete allNodesConnected['_private'];
    delete allNodesConnected['length'];

    objectToArray = Object.values(allNodesConnected);

    if (objectToArray.length > 0 && !result.includes(idNode)) {
      for (const n in objectToArray) {
        const targetIdNode = objectToArray[n].data('target');
        const sourceIdNode = objectToArray[n].data('source');
        if (targetIdNode !== 'n' && !result.includes(targetIdNode) && targetIdNode !== idNode) {
          result.push(targetIdNode);
        }
        if (sourceIdNode !== 'n' && !result.includes(sourceIdNode) && sourceIdNode !== idNode) {
          result.push(sourceIdNode);
        }
      }


    }


    return result;
  }
  getAllKeyNode(that: any, key: string) {
    const result = that.cy.nodes().map((el) => {
      return el.data(key);
    });
    return result;
  }
  rgbToHex(rgb: any) {
    let color: any;
    if (rgb.includes('#')) {
      color = rgb;
    } else {
      rgb = rgb.replace('rgb(', '');
      rgb = rgb.substring(0, rgb.length - 1);
      rgb = rgb.split(',');
      color = '#' + this.componentToHex(Number(rgb[0])) + this.componentToHex(Number(rgb[1]))
        + this.componentToHex(Number(rgb[2]));
    }
    return color;
  }
  componentToHex(c) {
    const hex = c.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
  }

  openModalUpdateNode(node, that) {
    const nodeId = node.data('id');

    if (nodeId !== 'n') {
      that.statusModal = 1;
      that.formNode.get('id').setValue(nodeId);
      that.openModal();
      that.onUpdate.emit(nodeId);
      that.formNode.get('name').setValue(node.data('label'));
      that.formNode.get('description').setValue(node.data('description'));
      that.color = node.style('background-color');
      that.formNode.get('color').setValue(this.rgbToHex(node.style('background-color')));
    } else {
      that.openModalNodeRoot();
    }
  }
  openModalAddNode(node, that) {
    that.statusModal = 0;

    that.formNode.get('id').setValue(node.data('id'));

    let color = this.colorService.checkedColor(that.arrayColorUsed);
    if (node.data('id') !== 'n') {
      color = node.style('background-color');
    }
    that.color = color;
    that.formNode.get('color').setValue(this.rgbToHex(color));
    that.openModal();
  }


  updateColorBranchNode(node, color, that) {
    const nodeConnected = this.getBranchConnected(node, [], [], that);
    for (let id in nodeConnected) {
      id = nodeConnected[id];
      const nd = this.getNodeById(id, that);
      nd.style('background-color', color);
      nd.data('color', color);
    }
  }


  async addNodeMiddleSinceEdge(edge, that) {
    this.targetNodeMiddle = this.getNodeById(edge.data('target'), that);
    this.sourceNodeMiddle = this.getNodeById(edge.data('source'), that);
    this.edgeMiddle = edge;
    that.formNode.get('id').setValue(this.sourceNodeMiddle.data('id'));
    that.formNode.get('color').setValue(this.rgbToHex(this.targetNodeMiddle.style('background-color')));
    that.statusModal = 2;
    that.openModal();

  }

  async  addEdgeNodeMiddle(that: any) {
    this.deleteEdge(that, this.edgeMiddle.data('id'));
    this.addEdge(this.nodeMiddle.data('id'), this.targetNodeMiddle.data('id'), 'false', that);
    this.edgeMiddle = null;
    this.sourceNodeMiddle = null;
    this.targetNodeMiddle = null;
    this.nodeMiddle = null;
  }

  addEdge(sourceNodeId: string, targetNodeId: string, secondary: string, that: any) {
    // console.log(sourceNodeId, targetNodeId);
    const idEdge = sourceNodeId + '-' + targetNodeId;
    that.cy.add({ group: 'edges', data: { id: idEdge, source: sourceNodeId, target: targetNodeId, secondary: secondary } });
  }

  deleteEdge(that: any, idEdge: string) {
    that.cy.remove('edge[id="' + idEdge + '"]');

  }

  detachNodeSinceEdge(edge: any, that: any) {
    const nodeTarget = this.getNodeById(edge.data('target'), that);

    let listEdges = this.filterEdges('target', nodeTarget.data('id'), that);
    if (listEdges.length > 0) {
      delete listEdges['_private'];
      delete listEdges['length'];
      listEdges = Object.values(listEdges);
      let e: any;
      for (e in listEdges) {
        e = listEdges[e];
        this.deleteEdge(that, e.data('id'));
      }


    }
    const children = this.getChildrenNode(nodeTarget, that);
    if (children.length > 0) {
      nodeTarget.data('last', 'false');
    } else {
      nodeTarget.data('last', 'true');
    }
    nodeTarget.data('detached', 'true');
    nodeTarget.data('color', this.rgbToHex('rgb(211,211,211)'));
    nodeTarget.style('background-color', this.rgbToHex('rgb(211,211,211)'));

    this.updateColorBranchNode(nodeTarget, this.rgbToHex('rgb(211,211,211)'), that);
    that.emitChange('update');

    return nodeTarget;

  }
  detachNode(node: any, that: any) {
    let listEdges = this.filterEdges('target', node.data('id'), that);
    if (listEdges.length > 0) {
      delete listEdges['_private'];
      delete listEdges['length'];
      listEdges = Object.values(listEdges);
      let e: any;
      for (e in listEdges) {
        e = listEdges[e];
        this.deleteEdge(that, e.data('id'));
      }

    }
    const children = this.getChildrenNode(node, that);
    if (children.length > 0) {
      node.data('last', 'false');
    } else {
      node.data('last', 'true');
    }
    node.data('detached', 'true');
    node.data('color', this.rgbToHex('rgb(211,211,211)'));
    node.style('background-color', this.rgbToHex('rgb(211,211,211)'));
    that.emitChange('update');

    this.updateColorBranchNode(node, this.rgbToHex('rgb(211,211,211)'), that);
  }

  filterEdges(property: string, value: string, that: any) {
    return that.cy.edges('[' + property + '="' + value + '"]');
  }
  attachNode(sourceNode, targetNode, that) {
    let color: string;
    this.addEdge(sourceNode.data('id'), targetNode.data('id'), 'false', that);
    if (sourceNode.data('id') === 'n') {
      color = this.colorService.checkedColor(that.arrayColorUsed);
    } else {
      color = sourceNode.style('background-color');
    }
    const children = this.getChildrenNode(targetNode, that);
    if (children.length > 0) {
      targetNode.data('last', 'false');
    } else {
      targetNode.data('last', 'true');
    }
    targetNode.data('detached', 'false');
    targetNode.data('color', color);
    targetNode.style('background-color', color);
    this.updateColorBranchNode(targetNode, color, that);

    that.emitChange('update');
    return targetNode;

  }

  deleteNode(that, nodeId) {
    that.cy.remove('node[id="' + nodeId + '"]');

  }

}
